<template>
  <div>
    <v-expansion-panel popout light class="futuristic-expansion-panel">
      <v-expansion-panel-content>
        <template slot="header">
          <div>
            <h4 class="earth-color futuristic-title">GLOBAL SEARCH</h4>
            <div class="title-decoration"></div>
          </div>
        </template>
        <template slot="actions">
          <v-icon color="#587e27" class="futuristic-icon">$vuetify.icons.expand</v-icon>
        </template>
        <search-tabs></search-tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <br />
    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <div>
          <h4 class="earth-color futuristic-title">Unticketed Booking Alerts</h4>
          <div class="title-decoration"></div>
        </div>
        <v-spacer></v-spacer>
        <div class="filter-controls">
          <v-btn :depressed="true"
                 @click="toggleSortOrder"
                 :color="sortNewFirst ? '#587e27' : '#757575'"
                 class="futuristic-btn sort-btn"
                 small>
            <v-icon small left>mdi-clock</v-icon>
            {{ sortNewFirst ? 'Newest First' : 'Oldest First' }}
          </v-btn>
          <v-text-field append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                        v-model="search"
                        class="futuristic-search"></v-text-field>
        </div>
      </v-card-title>
      <v-data-table :headers="columns"
                    :items="sortedUnticketedAlerts"
                    :search="search"
                    :rows-per-page-items="[10, 30, { text: 'All', value: -1 }]"
                    :disable-initial-sort="true"
                    :loading="$loadingTrue"
                    class="futuristic-table">
        <v-progress-linear slot="progress" color="#587e27" indeterminate class="futuristic-progress"></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td data-label="Gate" class="futuristic-cell">{{ props.item.gate }}</td>
          <td data-label="Destination" class="futuristic-cell">{{ props.item.destination }}</td>
          <td data-label="Adult" class="futuristic-cell">{{ props.item.adult }}</td>
          <td data-label="Children" class="futuristic-cell">{{ props.item.children }}</td>
          <td data-label="Infants" class="futuristic-cell">{{ props.item.infants || 0 }}</td>
          <td data-label="Guide" class="futuristic-cell">{{ props.item.guide || 0 }}</td>
          <td data-label="Name" class="futuristic-cell">{{ props.item.name || '' }}</td>
          <td data-label="Driver" class="futuristic-cell">{{ props.item.driver || '' }}</td>
          <td data-label="Mileage" class="futuristic-cell">{{ props.item.mileage || '' }}</td>
          <td data-label="Vehicle Registration"
              class="futuristic-cell"
              :style="props.item.created_at === latestUnticketedCreatedAt ? {
              backgroundColor: '#587e27',
              color: 'white',
              fontSize: '1.8em',
              fontWeight: '600',
              padding: '12px 20px',
              borderRadius: '8px',
              textAlign: 'center'
            } : {}">
            {{ props.item.vehicle_registration }}
          </td>
          <td data-label="Vehicle Type" class="futuristic-cell">{{ props.item.vehicle_type || '' }}</td>
          <td data-label="Alert" class="futuristic-cell">{{ props.item.note }}</td>
          <td data-label="Alert Date & Time" class="futuristic-cell">{{ formatDateTime(props.item.created_at) }}</td>
          <td data-label="Action Taken"
              class="futuristic-cell"
              :class="props.item.action_taken === 'Yes' ? 'action-taken-yes' : 'action-taken-no'"
              :style="props.item.booking_color">
            {{ props.item.action_taken }}
          </td>
          <td data-label="Action" class="futuristic-cell" v-if="props.item.alert == 'true'">
            <!-- Gate Keepers only: Edit and View/Update buttons -->
            <div class="action-buttons">
              <v-btn v-if="isGateKeeper" :depressed="true"
                     color="#3498db"
                     @click="editRawAlert(props.item)"
                     class="futuristic-btn edit-raw-btn">Edit</v-btn>
              <v-btn :depressed="true"
                     color="#f1c40f"
                     @click="updateViewAlertUpdate(props.item.note_public_id)"
                     class="futuristic-btn action-btn">View/Update</v-btn>
            </div>
            
          </td>
          <td data-label="Action" class="futuristic-cell" v-else></td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
      <div class="button-group">
        <v-btn :depressed="true"
               @click="getMore()"
               color="#00acc1"
               :loading="this.$store.state.LoadingStore.loading"
               class="futuristic-btn">GET MORE</v-btn>
        <v-btn :depressed="true"
               @click="getAllUnticketedAlerts()"
               color="#757575"
               :loading="this.$store.state.LoadingStore.loading"
               class="futuristic-btn">GET ALL</v-btn>
      </div>
      <div class="button-group">
        <v-btn :depressed="true"
               @click="getAlerts"
               :loading="$loadingTrue"
               color="#f57c00"
               class="futuristic-btn">VIEW ALL ALERTS</v-btn>
        <vue-json-to-csv :json-data="getInspectedUnticketedCSV"
                         csv-title="Booking Unticketed Alerts"
                         :labels="{
            gate: { title: 'Gate' },
            destination: { title: 'Destination' },
            adult: { title: 'Adult' },
            children: { title: 'Children' },
            infants: { title: 'Infants' },
            guide: { title: 'Guide' },
            name: { title: 'Name' },
            driver: { title: 'Driver' },
            mileage: { title: 'Mileage' },
            vehicle_registration: { title: 'Vehicle Registration' },
            vehicle_type: { title: 'Vehicle Type' },
            note: { title: 'Alert Details' },
            created_at: { title: 'Alert Date & Time' },
            session_user: { title: 'Alert Raised By' },
            update_notes: { title: 'Action Taken' }
          }">
          <v-btn :depressed="true"
                 color="#587e27"
                 :loading="$loadingTrue"
                 class="futuristic-btn">Download Alerts(CSV)</v-btn>
        </vue-json-to-csv>
      </div>
    </v-card>

    <!-- Edit Raw Dialog - Matching Add Gate Entry Design -->
    <v-dialog v-model="editRawDialog" persistent max-width="600px">
      <v-card class="dialog-card">
        <v-card-title class="dialog-header">
          <h4 class="earth-color dialog-title">EDIT GATE ENTRY DETAILS</h4>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeEditDialog" class="close-icon">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="dialog-content">
          <!-- Switch moved to top -->
          <v-switch v-model="isConservancyVehicle"
                    label="Conservancy Vehicle"
                    color="green" readonly
                    class="conservancy-switch">
            <template v-slot:label>
              <span class="switch-label">Conservancy Vehicle</span>
            </template>
          </v-switch>

          <!-- Show note based on selection -->
          <div v-if="isConservancyVehicle" class="vehicle-note mb-4">
            <v-alert type="info" dense outlined class="info-alert">
              <small>Select from registered conservancy vehicles and provide driver/mileage details</small>
            </v-alert>
          </div>
          <div v-else class="vehicle-note mb-4">
            <v-alert type="warning" dense outlined class="warning-alert">
              <small>Enter external vehicle registration number</small>
            </v-alert>
          </div>

          <v-container class="form-container">
            <!-- Entrance and Destination in a row -->
            <div class="row-inputs">
              <v-select label="Select Entrance"
                        v-model="editForm.gate"
                        :items="allGates"
                        item-text="gate_name"
                        item-value="gate_public_id"
                        :rules="[(v) => !!v || 'Entrance is required']"
                        required
                        outlined
                        dense
                        class="row-field" />

              <v-autocomplete label="Destination*"
                              v-model="editForm.destination"
                              :items="allDestinations"
                              item-text="destination_name"
                              item-value="destination_public_id"
                              :loading="$loadingTrue"
                              :rules="[(v) => !!v || 'Destination is required']"
                              required
                              outlined
                              dense
                              class="row-field"></v-autocomplete>
            </div>

            <!-- Name field -->
            <v-text-field label="Name*"
                          v-model="editForm.name"
                          :rules="[(v) => !!v || 'Name is required']"
                          required
                          outlined
                          dense
                          class="form-field" />

            <!-- Vehicle Type dropdown -->
            <v-select label="Vehicle Type*"
                      v-model="editForm.vehicle_type"
                      :items="vehicleTypes"
                      item-text="vehicle_charge_category"
                      item-value="vehicle_charge_public_id"
                      :rules="[(v) => !!v || 'Vehicle type is required']"
                      required
                      outlined
                      dense
                      class="form-field" />

            <!-- People counts -->
            <div class="number-inputs">
              <v-text-field label="Number of Adults"
                            type="number"
                            min="0"
                            step="1"
                            v-model="editForm.adult"
                            :placeholder="'0'"
                            :rules="[(v) => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 0) || 'Enter a whole number 0 or greater']"
                            required
                            outlined
                            dense
                            class="number-field"
                            @keydown="event => { if (event.key === '-') event.preventDefault() }"></v-text-field>

              <v-text-field label="Number of Children"
                            type="number"
                            min="0"
                            step="1"
                            v-model="editForm.children"
                            :placeholder="'0'"
                            :rules="[(v) => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 0) || 'Enter a whole number 0 or greater']"
                            required
                            outlined
                            dense
                            class="number-field"
                            @keydown="event => { if (event.key === '-') event.preventDefault() }"></v-text-field>
            </div>

            <div class="number-inputs">
              <v-text-field label="Number of Infants"
                            type="number"
                            min="0"
                            step="1"
                            v-model="editForm.infants"
                            :placeholder="'0'"
                            :rules="[(v) => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 0) || 'Enter a whole number 0 or greater']"
                            required
                            outlined
                            dense
                            class="number-field"
                            @keydown="event => { if (event.key === '-') event.preventDefault() }"></v-text-field>

              <v-text-field label="Number of Tour driver/guide"
                            type="number"
                            min="0"
                            step="1"
                            v-model="editForm.guide"
                            :placeholder="'0'"
                            :rules="[(v) => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 0) || 'Enter a whole number 0 or greater']"
                            required
                            outlined
                            dense
                            class="number-field"
                            @keydown="event => { if (event.key === '-') event.preventDefault() }"></v-text-field>
            </div>

            <!-- Vehicle Section -->
            <div class="vehicle-section">
              <v-autocomplete v-if="isConservancyVehicle"
                              label="Select Vehicle Registration*"
                              v-model="editForm.vehicle_registration"
                              :items="allAutos"
                              :item-text="item => item.auto"
                              item-value="auto"
                              :loading="isLoadingVehicles"
                              :rules="[(v) => !!v || 'Select a conservancy vehicle']"
                              required
                              outlined
                              dense
                              prepend-inner-icon="mdi-car"
                              class="form-field">
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.auto }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.vehicle_type">
                      {{ item.vehicle_type }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>

              <v-text-field v-else
                            label="Enter Vehicle Registration*"
                            v-model="editForm.vehicle_registration"
                            :rules="[(v) => !!v || 'Vehicle registration is required']"
                            required
                            outlined
                            dense
                            prepend-inner-icon="mdi-car"
                            class="form-field" />
            </div>

            <!-- Driver and Mileage Section -->
            <div v-if="isConservancyVehicle && editForm.vehicle_registration" class="driver-section">
              <v-autocomplete label="Select Driver*"
                              v-model="editForm.driver"
                              :items="allDrivers"
                              :item-text="item => item.driver"
                              item-value="driver"
                              :loading="isLoadingDrivers"
                              :rules="[(v) => !!v || 'Select a driver']"
                              required
                              outlined
                              dense
                              prepend-inner-icon="mdi-account"
                              class="row-field">
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.driver }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.phone && item.phone.trim()">
                      {{ item.phone }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>

              <v-text-field label="Enter Mileage*"
                            v-model="editForm.mileage"
                            type="number"
                            step="0.1"
                            min="0"
                            :rules="[
                            (v)=>
                !!v || 'Mileage is required',
                (v) => parseFloat(v) >= 0 || 'Mileage must be positive',
                (v) => !isNaN(parseFloat(v)) || 'Enter a valid number'
                ]"
                required
                outlined
                dense
                prepend-inner-icon="mdi-speedometer"
                class="form-field"
                />
            </div>
          </v-container>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn color="green submit-btn white--text"
                 text
                 @click="closeEditDialog"
                 :block="$vuetify.breakpoint.xsOnly">
            Close
          </v-btn>
          <v-btn v-if="editForm.destination && (editForm.adult > 0 || editForm.driver > 0 || editForm.guide > 0) && editForm.vehicle_registration"
                 color="green"
                 @click="saveRawEdit"
                 :loading="savingEdit"
                 class="action-btn submit-btn white--text"
                 :block="$vuetify.breakpoint.xsOnly">
            Save Changes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import SearchTabs from "./FindBooking";
  import VueJsonToCsv from "vue-json-to-csv";

  export default {
    components: { SearchTabs, VueJsonToCsv },
    name: "BookingsUnticketedAlert",
    data() {
      // Load user data from localStorage
      let lmenuData = null;
      try {
        lmenuData = JSON.parse(localStorage.getItem('unem') || '{}');
      } catch (e) {
        lmenuData = {};
      }

      return {
        search: "",
        page: 2,
        update_alert_dialog: false,
        alert_updates: false,
        editRawDialog: false,
        savingEdit: false,
        currentEditItem: null,
        isConservancyVehicle: false,
        sortNewFirst: true, // Default to show newest first
        vehicleTypes: [],
        isLoadingVehicles: false,
        isLoadingDrivers: false,
        lmenu: lmenuData, // Store user info
        editForm: {
          note: '',
          gate: '',
          destination: '',
          adult: '',
          children: '',
          infants: '',
          guide: '',
          vehicle_registration: '',
          vehicle_type: '',
          name: '',
          driver: '',
          mileage: ''
        },
        term: {
          key: "",
        },
        columns: [
          {
            text: "Gate",
            value: "gate",
          },
          {
            text: "Destination",
            value: "destination",
          },
          {
            text: "Adult",
            value: "adult",
          },
          {
            text: "Children",
            value: "children",
          },
          {
            text: "Infants",
            value: "infants",
          },
          {
            text: "Guide",
            value: "guide",
          },
          {
            text: "Name",
            value: "name",
          },
          {
            text: "Conservancy Driver",
            value: "driver",
          },
          {
            text: "Mileage",
            value: "mileage",
          },
          {
            text: "Vehicle Registration",
            value: "vehicle_registration",
          },
          {
            text: "Vehicle Type",
            value: "vehicle_type",
          },
          {
            text: "Alert",
            value: "note",
          },
          {
            text: "Alert Date & Time",
            value: "created_at",
          },
          {
            text: "Action Taken",
            value: "action_taken",
          },
        ],
      };
    },
    computed: {
      allDestinations() {
        return this.$store.state.DestinationStore.all_destinations || [];
      },
      allGates() {
        return this.$store.state.GateStore.all_gates || [];
      },
      allAutos() {
        return this.$store.state.AutoStore.all_autos || [];
      },
      allDrivers() {
        return this.$store.state.DriverStore.all_drivers || [];
      },
      allVehiclesFees() {
        return this.$store.state.VehicleFeeStore.all_vehicle_fees || [];
      },
      // Determine if current user is a Gate Keeper
      isGateKeeper() {
        return this.lmenu && this.lmenu.user_type !== 'Gate Keeper';
      },
      latestUnticketedCreatedAt() {
        const all = this.$store.state.BookingStore.inspection_unticketed_alerted_bookings;
        if (!all) return null;
        const filtered = all
          .filter(item => item.action_taken === 'No')
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Sort newest first
        return filtered.length > 0 ? filtered[0].created_at : null;
      },
      // Sort alerts based on sortNewFirst flag
      sortedUnticketedAlerts() {
        const all = this.$store.state.BookingStore.inspection_unticketed_alerted_bookings;
        if (!all) return [];

        const filtered = all.filter(item => item.action_taken === 'No');

        return filtered.sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);

          if (this.sortNewFirst) {
            // Newest first (descending)
            return dateB - dateA;
          } else {
            // Oldest first (ascending)
            return dateA - dateB;
          }
        });
      },
      getInspectedUnticketedCSV: function () {
        let all_notes = this.$store.state.BookingStore.inspection_unticketed_alerted_bookings;
        let notes_arr = [];
        if (all_notes == undefined) {
          return [];
        } else {
          for (let i = 0; i < all_notes.length; i++) {
            let notes_obj = {};
            notes_obj["gate"] = all_notes[i].gate || '';
            notes_obj["destination"] = all_notes[i].destination;
            notes_obj["adult"] = all_notes[i].adult;
            notes_obj["children"] = all_notes[i].children;
            notes_obj["infants"] = all_notes[i].infants || 0;
            notes_obj["guide"] = all_notes[i].guide || 0;
            notes_obj["name"] = all_notes[i].name || '';
            notes_obj["driver"] = all_notes[i].driver || '';
            notes_obj["mileage"] = all_notes[i].mileage || '';
            notes_obj["vehicle_registration"] = all_notes[i].vehicle_registration;
            notes_obj["vehicle_type"] = all_notes[i].vehicle_type || '';
            notes_obj["note"] = all_notes[i].note;
            notes_obj["created_at"] = this.formatDateTime(all_notes[i].created_at);
            notes_obj["session_user"] = all_notes[i].session_user;
            let updates = all_notes[i].update_notes;
            let updates_arr = [];
            if (updates && updates.length > 0) {
              for (let j = 0; j < updates.length; j++) {
                updates_arr.push(updates[j].alert_update);
              }
            }
            notes_obj["update_notes"] = updates_arr;
            notes_arr.push(notes_obj);
          }
          return notes_arr;
        }
      }
    },
    created() {
      this.$store.dispatch("get_unticketed_alert");
      this.$store.dispatch("get_all_destinations");
      this.$store.dispatch("get_all_gates");
      this.$store.dispatch("get_all_autos");
      this.$store.dispatch("get_all_drivers");
      this.$store.dispatch("get_all_vehicle_fees");
    },
    watch: {
      '$store.state.VehicleFeeStore.all_vehicle_fees': {
        handler(newVal) {
          if (newVal && newVal.length) {
            this.vehicleTypes = newVal.map((fee) => ({
              vehicle_charge_public_id: fee.vehicle_charge_public_id,
              vehicle_charge_category: fee.vehicle_charge_category,
            }));
          }
        },
        immediate: true,
      },
      'editForm.vehicle_registration': {
        handler(newVal) {
          if (newVal && this.isConservancyVehicle) {
            // Auto-populate vehicle type if it's a conservancy vehicle
            const selectedVehicle = this.allAutos.find(v => v.auto === newVal);
            if (selectedVehicle && selectedVehicle.vehicle_type_id) {
              // Find the matching vehicle type by ID
              const matchingType = this.vehicleTypes.find(
                type => type.vehicle_charge_public_id === selectedVehicle.vehicle_type_id
              );
              if (matchingType) {
                this.editForm.vehicle_type = matchingType.vehicle_charge_public_id;
              }
            }
          }
        },
        immediate: false,
      }
    },
    methods: {
      // Toggle sort order between Newest First and Oldest First
      toggleSortOrder() {
        this.sortNewFirst = !this.sortNewFirst;
      },

      formated_date(date) {
        if (!date) return '';
        return new Date(date).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      },
      formatDateTime(date) {
        if (!date) return '';
        return new Date(date).toLocaleString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
      },
      updateViewAlertUpdate: function (note_id) {
        this.$router.push({
          name: "ViewUpdateAlert",
          params: {
            note_id: note_id,
          },
        });
      },
      editRawAlert: function (item) {
        this.currentEditItem = item;

        // Determine if it's a conservancy vehicle
        this.isConservancyVehicle = !!item.driver || !!item.mileage;

        // Find the correct gate ID from gate name or ID
        let gateId = item.gate;
        if (gateId && this.allGates.length) {
          // Check if gate is a name or ID
          const foundGate = this.allGates.find(g =>
            g.gate_name === gateId || g.gate_public_id === gateId
          );
          if (foundGate) {
            gateId = foundGate.gate_public_id;
          }
        }

        // Find the correct destination ID from destination name or ID
        let destinationId = item.destination;
        if (destinationId && this.allDestinations.length) {
          const foundDest = this.allDestinations.find(d =>
            d.destination_name === destinationId || d.destination_public_id === destinationId
          );
          if (foundDest) {
            destinationId = foundDest.destination_public_id;
          }
        }

        // Find the correct vehicle type ID from vehicle type name or ID
        let vehicleTypeId = item.vehicle_type;
        if (vehicleTypeId && this.vehicleTypes.length) {
          const foundType = this.vehicleTypes.find(t =>
            t.vehicle_charge_category === vehicleTypeId ||
            t.vehicle_charge_public_id === vehicleTypeId
          );
          if (foundType) {
            vehicleTypeId = foundType.vehicle_charge_public_id;
          }
        }

        this.editForm = {
          note: item.note || '',
          gate: gateId || '',
          destination: destinationId || '',
          adult: item.adult || '',
          children: item.children || '',
          infants: item.infants || 0,
          guide: item.guide || 0,
          vehicle_registration: item.vehicle_registration || '',
          vehicle_type: vehicleTypeId || '',
          name: item.name || '',
          driver: item.driver || '',
          mileage: item.mileage || ''
        };

        this.editRawDialog = true;
      },
      closeEditDialog: function () {
        this.editRawDialog = false;
        this.currentEditItem = null;
        this.isConservancyVehicle = false;
        this.editForm = {
          note: '',
          gate: '',
          destination: '',
          adult: '',
          children: '',
          infants: '',
          guide: '',
          vehicle_registration: '',
          vehicle_type: '',
          name: '',
          driver: '',
          mileage: ''
        };
      },

      saveRawEdit: async function () {
        // Validate required fields
        if (!this.editForm.destination) {
          this.$toast.error('Please select a destination');
          return;
        }
        if (!this.editForm.vehicle_registration) {
          this.$toast.error('Please enter vehicle registration');
          return;
        }

        this.savingEdit = true;
        try {
          // Prepare data for API call - send public_ids directly
          const updateData = {
            note_public_id: this.currentEditItem.note_public_id,
            note: this.editForm.note || '',
            gate: this.editForm.gate,
            destination: this.editForm.destination,
            adult: parseInt(this.editForm.adult) || 0,
            children: parseInt(this.editForm.children) || 0,
            infants: parseInt(this.editForm.infants) || 0,
            guide: parseInt(this.editForm.guide) || 0,
            vehicle_registration: this.editForm.vehicle_registration,
            vehicle_type: this.editForm.vehicle_type,
            name: this.editForm.name || '',
            driver: this.editForm.driver || '',
            mileage: this.editForm.mileage || '',
            session_id: localStorage.getItem('lkjhgfdsa')
          };

          console.log('Saving update data with public_ids:', updateData);

          // Close dialog immediately after starting save
          this.closeEditDialog();

          // Dispatch action to update the raw data
          await this.$store.dispatch("update_raw_alert", updateData);

          // Refresh the alerts list
          await this.$store.dispatch("get_unticketed_alert");

          // Show success message
          this.$toast.success('Alert data updated successfully!');

        } catch (error) {
          console.error('Error saving raw edit:', error);
          this.$toast.error('Error saving changes. Please try again.');
          // Reopen dialog if there was an error so user can try again
          this.editRawDialog = true;
          this.currentEditItem = this.currentEditItem;
        } finally {
          this.savingEdit = false;
        }
      },

      searchTerm: function () {
        this.$store.dispatch("search_inspect_booking_by_key", this.term);
      },
      getUnticketed: function () {
        this.$store.dispatch("get_unticketed_alert");
      },
      getAlerts: function () {
        this.$router.push({
          name: "BookingsAlert",
        });
      },
      getMore() {
        this.loading = true;
        let data = {
          page: this.page,
        };
        if (this.page === 2) {
          this.$store.dispatch("get_more_unticketed_alert", data);
          this.page = this.page + 1;
        } else {
          this.$store.dispatch("get_more_unticketed_alert", data);
          this.page = this.page + 1;
        }
      },
      getAllUnticketedAlerts() {
        this.loading = true;
        let data = {
          page: 0,
        };
        this.$store.dispatch("get_more_unticketed_alert", data);
      },
    },
  };
</script>

<style scoped>
  /* Futuristic Card */
  .futuristic-card {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.3s ease;
  }

    .futuristic-card:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    }
  /* Expansion Panel */
  .futuristic-expansion-panel {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.3s ease;
  }

    .futuristic-expansion-panel:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    }
  /* Card Header */
  .card-header {
    background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
    padding: 16px;
    border-radius: 8px;
    flex-wrap: wrap;
  }

  .filter-controls {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .sort-btn {
    min-width: 130px;
    white-space: nowrap;
  }

  .earth-color {
    color: #587e27;
    font-weight: 600;
    margin: 0;
    font-size: 1.5rem;
  }

  .futuristic-title {
    position: relative;
    display: inline-block;
  }

    .futuristic-title::after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 100%;
      height: 2px;
      background: linear-gradient(90deg, #587e27, transparent);
      transform: scaleX(0);
      transform-origin: right;
      transition: transform 0.3s ease;
    }

    .futuristic-title:hover::after {
      transform: scaleX(1);
      transform-origin: left;
    }

  .title-decoration {
    height: 4px;
    background: linear-gradient(90deg, #587e27, transparent);
    margin-bottom: 16px;
    width: 100px;
  }
  /* Input Fields */
  .futuristic-search > > > .v-input__slot {
    border-radius: 8px;
    background: #f5f7fa;
    border: 1px solid rgba(46, 125, 50, 0.2);
    transition: all 0.3s ease;
  }

    .futuristic-search > > > .v-input__slot:hover {
      border-color: #587e27;
      box-shadow: 0 0 10px rgba(46, 125, 50, 0.2);
    }

    .futuristic-search > > > .v-input__slot:focus-within {
      border-color: #587e27;
      box-shadow: 0 0 15px rgba(46, 125, 50, 0.3);
    }
  /* Buttons */
  .futuristic-btn {
    border-radius: 8px;
    text-transform: none;
    font-weight: 500;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;
    margin: 8px;
  }

    .futuristic-btn:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .futuristic-btn::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
      transition: left 0.7s ease;
    }

    .futuristic-btn:hover::before {
      left: 100%;
    }

  .action-btn {
    background: linear-gradient(135deg, #f1c40f 0%, #f4d03f 100%) !important;
    color: white !important;
  }

  .edit-raw-btn {
    background: linear-gradient(135deg, #3498db 0%, #5dade2 100%) !important;
    color: white !important;
  }

  .submit-btn {
    background: linear-gradient(135deg, #587e27 0%, #4caf50 100%) !important;
  }

  .action-buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
  /* Data Table */
  .futuristic-table {
    border-radius: 8px;
    background: #ffffff;
  }

    .futuristic-table > > > th {
      color: #587e27;
      font-weight: 600;
      background: linear-gradient(45deg, #e8f5e9 0%, #f1f8e9 100%) !important;
      font-size: 0.9rem;
      padding: 16px 8px;
      border-bottom: 2px solid #587e27;
    }

    .futuristic-table > > > tr:hover {
      background: rgba(232, 245, 233, 0.3) !important;
    }

  .futuristic-cell {
    padding: 12px 8px;
    border-bottom: 1px solid rgba(46, 125, 50, 0.1);
    transition: background-color 0.2s ease;
  }

    .futuristic-cell:hover {
      background: rgba(232, 245, 233, 0.2);
    }

  .action-taken-yes {
    color: #587e27;
    font-weight: 600;
  }

  .action-taken-no {
    color: #f44336;
    font-weight: 600;
  }
  /* Progress Bar */
  .futuristic-progress {
    height: 3px !important;
    border-radius: 3px;
  }
  /* Alerts */
  .futuristic-alert {
    border-radius: 8px;
    background: #fff5f5;
    border: 1px solid rgba(244, 67, 54, 0.2);
  }
  /* Button Group */
  .button-group {
    display: flex;
    gap: 16px;
    margin: 16px 0;
    justify-content: center;
    flex-wrap: wrap;
  }
  /* Icons */
  .futuristic-icon {
    filter: drop-shadow(0 2px 4px rgba(46, 125, 50, 0.3));
  }

  /* Dialog Styles */
  .dialog-card {
    background: #ffffff;
  }

  .dialog-header {
    background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
    padding: 16px;
  }

  .dialog-title {
    font-size: 1.5rem;
    margin: 0;
  }

  .dialog-content {
    padding: 16px;
  }

  .form-container {
    padding: 0;
  }

  .row-inputs {
    display: flex;
    gap: 16px;
  }

  .row-field {
    flex: 1;
  }

  .number-inputs {
    display: flex;
    gap: 16px;
  }

  .number-field {
    flex: 1;
  }

  .form-field {
    margin-bottom: 16px;
  }

  .dialog-actions {
    padding: 16px;
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }

  .conservancy-switch {
    margin: 8px 0;
  }

  .switch-label {
    font-weight: 600;
    color: #587e27;
  }

  .vehicle-note {
    margin-top: 8px;
  }

  .info-alert {
    background: #e8f5e9;
    border-color: #587e27;
    color: #2e7d32;
  }

  .warning-alert {
    background: #fff3e0;
    border-color: #ff9800;
    color: #ef6c00;
  }

  .driver-section {
    margin-top: 16px;
    padding: 16px;
    background: #f5f7fa;
    border-radius: 8px;
    border: 1px solid rgba(88, 126, 39, 0.2);
  }

  .close-icon {
    cursor: pointer;
    transition: all 0.2s ease;
  }

    .close-icon:hover {
      transform: rotate(90deg);
      color: #f44336;
    }

  .futuristic-input > > > .v-input__slot {
    border-radius: 8px;
    transition: all 0.3s ease;
  }

    .futuristic-input > > > .v-input__slot:hover {
      border-color: #587e27;
    }

  /* Responsive Adjustments */
  @media (max-width: 960px) {
    .card-header {
      padding: 12px;
      flex-direction: column;
    }

    .filter-controls {
      width: 100%;
      margin-top: 12px;
      flex-direction: column;
    }

    .sort-btn {
      width: 100%;
    }

    .futuristic-search {
      width: 100%;
    }

    .earth-color {
      font-size: 1.25rem;
    }

    .futuristic-title::after {
      bottom: -3px;
    }

    .title-decoration {
      width: 80px;
      height: 3px;
    }

    .futuristic-search > > > .v-input__slot {
      margin-bottom: 12px;
    }

    .futuristic-btn {
      margin: 6px;
      font-size: 0.9rem;
    }

    .button-group {
      flex-direction: column;
      gap: 8px;
    }

    .futuristic-table > > > th {
      padding: 12px 6px;
      font-size: 0.8rem;
    }

    .futuristic-cell {
      padding: 10px 6px;
    }

    .action-buttons {
      flex-direction: column;
    }

    .row-inputs,
    .number-inputs {
      flex-direction: column;
      gap: 12px;
    }
  }

  @media (max-width: 600px) {
    .card-header {
      flex-direction: column;
      align-items: flex-start;
      padding: 8px;
    }

    .filter-controls {
      width: 100%;
      margin-top: 12px;
    }

    .futuristic-search {
      width: 100%;
      margin-top: 12px;
    }

    .sort-btn {
      width: 100%;
      margin-bottom: 8px;
    }

    .earth-color {
      font-size: 1.1rem;
    }

    .title-decoration {
      width: 60px;
      height: 2px;
    }

    .futuristic-btn {
      width: 100%;
      margin: 4px 0;
      font-size: 0.85rem;
    }

    .button-group {
      flex-direction: column;
      align-items: center;
    }

    .futuristic-table {
      font-size: 0.85rem;
    }

      .futuristic-table > > > th {
        padding: 8px 4px;
        font-size: 0.75rem;
      }

    .futuristic-cell {
      padding: 8px 4px;
    }

    .action-btn,
    .edit-raw-btn {
      width: 100%;
    }

    .driver-section {
      padding: 12px;
    }
  }
</style>
